import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  installedModules: [],
  activeModules: [],
  loading: false,
  error: null,
};

const moduleSlice = createSlice({
  name: 'module',
  initialState,
  reducers: {
    setInstalledModules: (state, action) => {
      state.installedModules = action.payload;
    },
    setActiveModules: (state, action) => {
      state.activeModules = action.payload;
    },
    installModule: (state, action) => {
      state.installedModules.push(action.payload);
    },
    uninstallModule: (state, action) => {
      state.installedModules = state.installedModules.filter(
        (m) => m.id !== action.payload
      );
    },
  },
});

export const {
  setInstalledModules,
  setActiveModules,
  installModule,
  uninstallModule,
} = moduleSlice.actions;
export default moduleSlice.reducer;
